enum MemberIconContent {
  PROGRESS_BAR = 'PROGRESS_BAR',
  MEMBER_ICON = 'MEMBER_ICON',
  GRADE_TEXT = 'GRADE_TEXT',
}

export default MemberIconContent;
